// extracted by mini-css-extract-plugin
export default {"price":"q7-z","onSale":"r7-z","msrpLabelPrice":"s7-z","msrpLabel":"t7-z","originalPrice":"u7-z","percentOff":"v7-z"};